<label>
  <ng-content select="label"></ng-content>
</label>
<ol>
  @for (option of options; track option; let i = $index) {
    <li
      (click)="control.patchValue(option.value)"
      [ngClass]="{ selected: option.selected }"
      >
      <div class="icon">
        @if (option.isSvg) {
          <mat-icon [svgIcon]="option.currentIcon"></mat-icon>
        }
        @if (!option.isSvg && option.currentIcon) {
          <mat-icon>{{ option.currentIcon }}</mat-icon>
        }
        @if (option.currentImage) {
          <img [src]="option.currentImage" />
        }
      </div>
      <label>{{ option.currentLabel }}</label>
    </li>
  }
</ol>
